import { Theme } from '@mui/material';

export const SCROLLER_THEME = 'os-theme-dark os-theme-custom';

export const scrollerStyles = (theme: Theme, additionalStyles = {}) => ({
  '& .os-theme-custom': {
    '&.os-scrollbar-vertical': {
      padding:
        'var(--os-padding-axis) 4px var(--os-padding-axis) var(--os-padding-perpendicular)',
    },

    '&.os-scrollbar-horizontal': {
      padding:
        'var(--os-padding-axis) var(--os-padding-perpendicular) 4px var(--os-padding-perpendicular)',
    },

    '--os-handle-bg': theme.palette.grey[300],
    '--os-handle-bg-hover': theme.palette.grey[300],
    '--os-handle-bg-active': theme.palette.grey[400],
    '--os-size': '14px',
    '--os-handle-border-radius': '4px',
    '--os-handle-interactive-area-offset': '0px',

    ...additionalStyles,
  },
});
